import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link as RRLinkUnstyled } from 'react-router-dom';
import color from 'tinycolor2';
import { Tooltip } from '@pearsontechnology/aero-components';

export const Nav = styled.nav`
  flex: 1 1 auto;
  overflow: hidden;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

export const P = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  color: ${(props) => props.theme['color.text.body']};
  flex: 1 1 auto;

  /* chevron icon */
  i {
    color: ${(props) => color(props.theme['color.text.body']).setAlpha(0.4).toString()};
    margin: 0 4px;
  }
`;

export const StyledTooltip = styled(Tooltip).attrs((props) => ({
  placement: `${props.placement}` ? `${props.placement}` : 'top',
}))`
  z-index: 8;
  overflow-wrap: break-word;
  word-wrap: break-word;
  text-align: left;
  padding: 3px 5px;
  line-height: 11px;
  font-size: 11px;
  box-shadow: 0 0 0px 0 rgba(0, 0, 0, 0.1), 0 0px 0px 0 rgba(0, 0, 0, 0.15), 0 0px 10px 0 rgba(0, 0, 0, 0.2);
  ${(props) => props.maxWidth && `max-width: ${props.maxWidth}px`};
  &::after {
    overflow-wrap: break-word;
    word-wrap: break-word;
    white-space: pre-line;
    z-index: -1;
    left: 10%;
  }
`;

export const PublishStatusCircle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  margin-left: 4px;
  position: relative;
`;

export const Label = styled.span`
  line-height: 24px;
  color: ${(props) => props.last
    ? props.theme['color.text.body']
    : props.theme['color.text.light']
};
  font-size: 14px;
`;

export const RRLink = styled(({ last, ...rest }) => <RRLinkUnstyled {...rest} />)`
  line-height: 24px;
  flex: 0 1 auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;

  color: ${(props) => props.last
    ? props.theme['color.text.body']
    : props.theme['color.text.light']
};
  font-size: 14px;
  text-decoration: none;

  &:hover {
    color: ${(props) => props.theme['color.text.body']};
  }

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    overflow: visible;
    flex: 0 0 auto;
  }
`;

RRLink.propTypes = {
  last: PropTypes.bool,
};
